/**
 * @flow
 * Created by neo on 05.03.17.
 */
import mobx, {observable, action, computed} from 'mobx';
import FlightOffer from '../FlightOffer';
import { FlightOfferAircraft } from '../FlightOffer';
import Passenger from './Passenger';
import Payment from '../Payment';
import BackendFactory from '../../Services/BackendFactory';
import Address from '../Address';
import Voucher from '../Voucher';
import moment from 'moment-timezone';
import AbstractBookingRequest from './AbstractBookingRequest';

export default class FlightOfferBookingRequest extends AbstractBookingRequest {
  @observable flightOffer: FlightOffer = new FlightOffer();
  @observable aircraft: FlightOfferAircraft = new FlightOfferAircraft();
  @observable start_time: string;

  constructor(json?: any) {
    super(json);

    if(json) {
      this.flightOffer = new FlightOffer(json.flightOffer);
      this.aircraft = new FlightOfferAircraft(json.aircraft || this.flightOffer.aircraft_offers[0]);
      this.start_time = json.start_time;
      this.payment_types = (json.payment_types || this.flightOffer.payment_types : []).map(p => new Payment(p));
      this.payment = new Payment(json.payment || this.payment_types[0]);
    }
  }

  @computed get validDate(): boolean {
    return this.start_time && this.start_time.length > 0 && moment(this.start_time, 'YYYY-MM-DD HH:mm:ss', true).isValid();
  }

  @computed get valid(): boolean {
    return this.validClient && this.address.valid && this.validDate && this.check_insurance_info && this.check_safety_info;
  }

  @action async send(): Promise<?string> {
    const backend = await BackendFactory();
    const startTimeUTC = moment(this.start_time).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');

    // this.aircraft.id is flight_offer_aircraft.id not aircraft_model.id
    const res = await backend.post('/offer/' + this.flightOffer.id + '/aircraft/' + this.aircraft.id + '/book', {
      start_time: startTimeUTC,
      booking: {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone: this.phone,
        is_exclusive: this.is_exclusive,
        note: this.note,
        check_insurance_info: this.check_insurance_info,
        check_safety_info: this.check_safety_info,
        carry_on_count: this.carry_on_count || 0,
        suitcase_count: this.suitcase_count || 0,
        price: this.actualPrice
      },
      passengers: mobx.toJS(this.passengers),
      payment: {
        token: this.payment.token,
        id: this.payment.id,
        name: this.payment.name,
        total_price: this.actualPrice + this.paymentMethodCommission
      },
      address: mobx.toJS(this.address),
      voucher: mobx.toJS(this.voucher),
      promo_code: mobx.toJS(this.promo_code)
    });

    if(res.ok) {
      return res.data;
    }

    if (res.data && res.data.error) {
      return {
        error: res.data.error
      };
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Booking/BookingRequest.js